<div>
  {{formatMessage('Password requirements')}}
  <div *ngIf="passwordPolicy.requireDigit">
    <i class="dx-icon-check"></i> {{formatMessage('at least one digit')}} <br />
  </div>
  <div *ngIf="passwordPolicy.requireLowercase">
    <i class="dx-icon-check"></i> {{formatMessage('at least one lowercase letter')}}
  </div>
  <div *ngIf="passwordPolicy.requireUppercase">
    <i class="dx-icon-check"></i> {{formatMessage('at least one uppercase letter')}}
  </div>
  <div *ngIf="passwordPolicy.requireNonAlphanumeric">
    <i class="dx-icon-check"></i> {{formatMessage('at least one character !@#$%^&*()_+')}}
  </div>
  <div *ngIf="passwordPolicy.requiredLength > 0">
    <i class="dx-icon-check"></i> {{formatMessage('at least {0} characters', requiredLengthValue)}}
  </div>
  <div *ngIf="passwordPolicy.requiredUniqueChars > 0">
    <i class="dx-icon-check"></i> {{formatMessage('at least {0} unique characters', requiredUniqueCharsValue)}}
  </div>
</div>
<br />
<form (submit)="onSubmit($event)">
  <dx-form [formData]="form" [disabled]="loading">

    <dxi-item dataField="password" editorType="dxTextBox"
      [editorOptions]="{ stylingMode: 'filled', placeholder: formatMessage('Password'), mode: 'password' }">
      <dxo-label [visible]="false"></dxo-label>
      <dxi-validation-rule
        type="required"
        [message]="formatMessage('{0} is required field', formatMessage('Password'))">
      </dxi-validation-rule>
    </dxi-item>

    <dxi-item dataField="confirmPassword" editorType="dxTextBox"
      [editorOptions]="{ stylingMode: 'filled', placeholder: formatMessage('Confirm password'), mode: 'password' }">
      <dxo-label [visible]="false"></dxo-label>
      <dxi-validation-rule
        type="required"
        [message]="formatMessage('{0} is required field', formatMessage('Confirm password'))">
      </dxi-validation-rule>
      <dxi-validation-rule type="custom" [message]="formatMessage('Passwords do not match')" [validationCallback]="confirmPassword"></dxi-validation-rule>
    </dxi-item>

    <dxi-item itemType="button">
      <dxo-button-options width="100%" type="default" [useSubmitBehavior]="true" [template]="'changePasswordTemplate'">
      </dxo-button-options>
    </dxi-item>

    <ng-container *dxTemplate="let item of 'changePasswordTemplate'">
      <div>
        <span class="dx-button-text">
          <ng-container *ngIf="loading; else notLoading">
            <dx-load-indicator width="24px" height="24px" [visible]="true"></dx-load-indicator>
          </ng-container>
          <ng-template #notLoading>{{formatMessage('Save')}}</ng-template>
        </span>
      </div>
    </ng-container>

  </dx-form>
</form>
